import { combineReducers } from "redux";
import { reducer as currentEstate } from "./currentEstate/currentEstateSlice";
import { reducer as estates } from "./estateList/estateListSlice";

export default combineReducers({
  estates,
  currentEstate,
});
